import { render, staticRenderFns } from "./Scale_configuration_add.vue?vue&type=template&id=46df46cb&style=height%3A100%25"
import script from "./Scale_configuration_add.vue?vue&type=script&lang=js"
export * from "./Scale_configuration_add.vue?vue&type=script&lang=js"
import style0 from "./Scale_configuration_add.vue?vue&type=style&index=0&id=46df46cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports